import { Row, Table, TableColumnsType, TableProps, Typography } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import HistoryAction from "src/components/History/HistoryAction";
import { Filter, HistoryData, OptionFilter, ActionDisplays } from "src/entity/history/history-entity";

type OnChange = NonNullable<TableProps<any>["onChange"]>;
type Filters = Parameters<OnChange>[1];

interface Props {
  selectedMenu: string;
  historys: HistoryData[];
  loading: boolean;
  optionsFilter: OptionFilter[];
  total: number;
  companyId: string;
  onChangeTable: (current: number, pageSize: number, query: string) => void;
}

const { Text } = Typography;

const HistoryTable: React.FC<Props> = ({ selectedMenu, historys, loading, optionsFilter, total, companyId, onChangeTable }) => {
  const actionDisplays = ActionDisplays;
  const [current, setCurrent] = useState(1);
  const pageSize = 10;
  const [filteredInfo, setFilteredInfo] = useState<Filters>({});

  const resetFilter = () => {
    setFilteredInfo({});
  };

  useEffect(() => {
    if (selectedMenu) {
      setFilteredInfo({});
      setCurrent(1);
    }
  }, [selectedMenu]);

  useEffect(() => {
    resetFilter();
  }, [companyId]);

  const onTableChange: TableProps<HistoryData>["onChange"] = (pagination: any, filters: any) => {
    let current = pagination.current;
    let pageSize = pagination.pageSize;

    setFilteredInfo(filters);

    const query = Object.entries(filters as Filter)
      .filter(([, value]) => value && value != "")
      .map(([key, value]) => `&${key}=[${value.join(",")}]`)
      .join("");

    setCurrent(current);
    onChangeTable(current, pageSize, query);
  };

  const mapFilter = (key: string): Filter[] | [] => {
    const resultFilter = optionsFilter.find((item) => item.key === key)?.filter;
    if (resultFilter) {
      const filter: Filter[] = resultFilter?.map((value: any) => {
        let text = "";
        if (key === "updatedAt") {
          text = `${moment(value).format("YYYY-MM-DD HH:mm:ss")}`;
        } else if (key === "updatedBy") {
          text = value;
        } else if (key === "action") {
          const actionText = actionDisplays.find((item) => item.key === value);
          if (actionText) {
            text = actionText.label;
          }
        }
        return {
          text,
          value: value,
        };
      });
      return filter;
    } else {
      return [];
    }
  };

  const columns: TableColumnsType = [
    {
      title: "No",
      dataIndex: "no",
      align: "center",
      width: 50,
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Action Datetime",
      dataIndex: "updatedAt",
      align: "center",
      filters: mapFilter("updatedAt"),
      filteredValue: filteredInfo.updatedAt || null,
      width: 50,
      render: (value) => <Text>{moment(value).format("YYYY-MM-DD HH:mm:ss")}</Text>,
    },
    {
      title: "Action By",
      dataIndex: "updatedBy",
      align: "center",
      filters: mapFilter("updatedBy"),
      filteredValue: filteredInfo.updatedBy || null,
      width: 50,
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      filters: mapFilter("action"),
      filteredValue: filteredInfo.action || null,
      width: 50,
      render: (value, record) => {
        return <HistoryAction action={value} detail={record} />;
      },
    },
  ];
  return (
    <div>
      <Row className="w-full">
        <Table
          className="w-full"
          columns={columns}
          dataSource={historys}
          loading={loading}
          onChange={onTableChange}
          pagination={{
            size: "small",
            showSizeChanger: false,
            current,
            pageSize,
            total,
          }}
        />
      </Row>
    </div>
  );
};

export default HistoryTable;
